export const ChapterIcons = {
  null: '/assets/images/chapter_type_text.svg',
  TEXT: '/assets/images/chapter_type_text.svg',
  VIDEO: '/assets/images/chapter_type_video.svg',
  EXERCISE: '/assets/images/chapter_type_exercise.svg',
  TEXT_ACTIVE: '/assets/images/chapter_type_text_active.svg',
  VIDEO_ACTIVE: '/assets/images/chapter_type_video_active.svg',
  EXERCISE_ACTIVE: '/assets/images/chapter_type_exercise_active.svg',
};
